import React, { useState, useEffect } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  useLocation,
} from "react-router-dom";
import SideBarAndContent from "../SideBarAndContent";
import Home from "./Home";
import FamilyTree from "./FamilyTree";
import AskAi from "./FamilyTree/AskAi";
import Bulletin from "./Bulletin";
import Marketplace from "./Marketplace";
import Scrapbook from "./Scrapbook";
import FamilyConnect from "./FamilyConnect";
import Correspondence from "./Correspondence";
import Settings from "./Settings";
import Admin from "./Admin";
import FootprintRedirect from "./FootprintRedirect";
import { NotFound, RouteError } from "./RouteFallbacks";

// Layout that keeps the Family Tree alive across page navigation.
// The tree only builds once (the first time you visit /tree), then stays
// in the background when you switch to other pages. Coming back is instant.
function AppLayout() {
  const location = useLocation();
  const isTreePage = location.pathname === "/tree";
  const [hasVisitedTree, setHasVisitedTree] = useState(false);

  useEffect(() => {
    if (isTreePage) setHasVisitedTree(true);
  }, [isTreePage]);

  return (
    <SideBarAndContent>
      {/* FamilyTree: only mounts after first visit, then stays alive (hidden) */}
      {hasVisitedTree && (
        <div className={isTreePage ? "h-full w-full" : "hidden"}>
          <FamilyTree />
        </div>
      )}
      {/* Other pages render normally via the router outlet */}
      {!isTreePage && <Outlet />}
    </SideBarAndContent>
  );
}

// Two safety nets. A page that crashes shows RouteError in the page area, with
// the menu still there (the inner errorElement); a crash in the layout itself,
// the Family Tree included, shows it full screen (the outer one). Without them
// React Router shows its own raw developer error screen.
export const routes = [
  {
    element: <AppLayout />,
    errorElement: <RouteError fullScreen />,
    children: [
      {
        errorElement: <RouteError />,
        children: [
          { path: "/", element: <Home /> },
          { path: "/tree", element: null },
          { path: "/ask-ai", element: <AskAi /> },
          { path: "/bulletin", element: <Bulletin /> },
          { path: "/marketplace", element: <Marketplace /> },
          { path: "/footprint", element: <FootprintRedirect /> },
          { path: "/scrapbook", element: <Scrapbook /> },
          { path: "/connect", element: <FamilyConnect /> },
          { path: "/messages", element: <Correspondence /> },
          { path: "/settings/*", element: <Settings /> },
          { path: "/admin", element: <Admin /> },
          // Any other address: a friendly "page not found" with a way home.
          { path: "*", element: <NotFound /> },
        ],
      },
    ],
  },
];

const router = createBrowserRouter(routes);

function UserDashboard() {
  return <RouterProvider router={router} />;
}

export default UserDashboard;
